import {
  ArrowLeft,
  ShieldCheck,
  KeyRound,
  RefreshCw,
  Unplug,
} from "lucide-react";
import { Link } from "react-router-dom";

export default function GoogleConnection() {
  return (
    <HelpArticle
      title="Google Connection"
      description="Learn how RevUShield connects to Google Business Profile and how to manage access."
    >
      <Step icon={ShieldCheck} title="Authorize with Google">
        RevUShield only accesses Google Business Profile data after you approve
        the requested permissions.
      </Step>

      <Step icon={KeyRound} title="Permissions are required">
        Google permissions allow RevUShield to sync reviews and assist with
        response workflows.
      </Step>

      <Step icon={RefreshCw} title="Reconnecting may fix sync issues">
        If reviews stop syncing, reconnecting your Google account can refresh
        permissions.
      </Step>

      <Step icon={Unplug} title="You can revoke access">
        You can disconnect RevUShield in Settings or revoke access directly from
        your Google account permissions.
      </Step>
    </HelpArticle>
  );
}

function HelpArticle({ title, description, children }) {
  return (
    <div className="max-w-4xl mx-auto space-y-6">
      <Link
        to="/help"
        className="inline-flex items-center gap-2 text-sm font-medium text-slate-600 hover:text-slate-900"
      >
        <ArrowLeft size={16} />
        Back to Help
      </Link>

      <div className="bg-white border border-slate-200 rounded-2xl shadow-sm p-6 md:p-8">
        <h1 className="text-3xl font-bold text-slate-900">{title}</h1>
        <p className="text-slate-500 mt-2">{description}</p>

        <div className="mt-8 space-y-4">{children}</div>
      </div>
    </div>
  );
}

function Step({ icon: Icon, title, children }) {
  return (
    <div className="border border-slate-200 rounded-2xl p-5 flex gap-4">
      <div className="h-11 w-11 rounded-xl bg-indigo-100 text-indigo-600 flex items-center justify-center shrink-0">
        <Icon size={21} />
      </div>

      <div>
        <h2 className="font-semibold text-slate-900">{title}</h2>
        <p className="text-sm text-slate-500 mt-1">{children}</p>
      </div>
    </div>
  );
}
